module.exports = __webpack_public_path__ + "img/shield.45dd784b.svg";